module.exports = __webpack_public_path__ + "img/logo-linkedin-294x294.c2f28910.png";